import React from "react";
import "./Below_Banner_section.css";

function About_Us_Below_Banner_section({ headingText, ContentText }) {
  return (
    <section className="Below_Banner_section">
      <div className="container">
        <h3 className="">{headingText}</h3>
        <p>{ContentText}</p>
      </div>
    </section>
  );
}

export default About_Us_Below_Banner_section;
